import script from "./xtx-steps.vue?vue&type=script&lang=js"
export * from "./xtx-steps.vue?vue&type=script&lang=js"

import "./xtx-steps.vue?vue&type=style&index=0&id=7b969a85&lang=less"

const __exports__ = script;

export default __exports__